import React from 'react';

import { Amplify } from 'aws-amplify';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';

import App from './App';
import ErrorBoundary, { RootErrorFallback } from './components/ErrorBoundary';
import GlobalStyles from './index.styles';
import { configureDayjs } from './utils/common/dayjsConfig';

// Typescript struggles to find some of the deeply nested types using pnpm
// Explicitly importing these types fix it
import type {} from '@emotion/styled';
import type {} from '@mui/system';
import type {} from '@mui/types';

const {
  REACT_APP_GA_MEASUREMENT_ID,
  REACT_APP_AWS_COGNITO_USER_POOL_ID,
  REACT_APP_AWS_COGNITO_APP_CLIENT_ID,
  REACT_APP_AWS_COGNITO_ENDPOINT,
} = process.env;

/**
 * Configure dayjs plugins and locale for every chunk
 */
configureDayjs();

/**
 * Configure Google Analytics
 */
ReactGA.initialize(REACT_APP_GA_MEASUREMENT_ID as string);

/**
 * Configure Amplify authentication
 */
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: REACT_APP_AWS_COGNITO_USER_POOL_ID || '',
      userPoolClientId: REACT_APP_AWS_COGNITO_APP_CLIENT_ID || '',
      userPoolEndpoint: REACT_APP_AWS_COGNITO_ENDPOINT || '',
    },
  },
});

/**
 * Render the application
 */
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <GlobalStyles />
    <ErrorBoundary fallback={<RootErrorFallback />}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
